//Table sorting
let sortableTableHead = $('.sortable-th');

sortableTableHead.prepend('<i class="fa fa-sort mr-2"></i>');

sortableTableHead.click(function () {
    let self = $(this);
    let table = self.parents('table').eq(0);
    let tableBody = table.find('tbody').eq(0);
    let rows = tableBody.find('tr').toArray().sort(comparer($(this).index()));

    sortableTableHead.removeClass('text-primary');
    self.addClass('text-primary');

    this.asc = !this.asc
    if (!this.asc) {
        rows = rows.reverse()
    }
    for (let i = 0; i < rows.length; i++) {
        table.append(rows[i])
    }
})

/**
 *
 * @param index
 * @returns {function(*, *): number|number}
 */
function comparer(index) {
    return function (a, b) {
        let valA = getCellValue(a, index), valB = getCellValue(b, index)
        return $.isNumeric(valA) && $.isNumeric(valB) ? valA - valB : valA.toString().localeCompare(valB)
    }
}

/**
 *
 * @param row
 * @param index
 * @returns {*|jQuery}
 */
function getCellValue(row, index) {
    if ($(row).children('td').eq(index).data('date')) {
        return $(row).children('td').eq(index).data('date')
    } else {
        return $(row).children('td').eq(index).text()
    }
}

document.addEventListener("DOMContentLoaded", () => {
    for (let elem of document.getElementsByClassName('default-sort')) {
        elem.click();
    }
});
